<div class="space-y-2 p-3 border border-divider rounded-lg bg-card shadow-sm">
    <div class="flex justify-between items-center mb-3">
        <div>
            <h3 class="text-base font-semibold text-default">Set Opening Hours</h3>
            <p class="text-sm text-secondary">
                Configure your weekly schedule. Use the menu to quickly copy hours.
            </p>
        </div>
    </div>

    <ng-container *ngIf="internalHours">
        <!-- Grid Layout: Day Name | Toggle | Controls | Actions -->
        <div *ngFor="let day of internalHours; let dayIdx = index"
             class="grid grid-cols-1 sm:grid-cols-[80px_100px_1fr_40px] gap-x-3 gap-y-2 items-start py-2 px-2 rounded-md hover:bg-hover transition-colors border-b border-dashed border-divider last:border-0">

            <!-- 1. Day Name -->
            <span class="text-sm font-medium text-default pt-2">{{ day.day }}</span>

            <!-- 2. Open/Close Toggle -->
            <div class="flex items-center space-x-1.5 pt-1.5">
                <button type="button" (click)="handleToggleOpen(dayIdx)"
                        class="flex items-center space-x-1.5 focus:outline-none transition-opacity hover:opacity-80"
                        [matTooltip]="day.isOpen ? 'Mark as Closed' : 'Mark as Open'">
                    <mat-icon [svgIcon]="day.isOpen ? 'heroicons_solid:check-circle' : 'heroicons_solid:x-circle'"
                              [ngClass]="{'text-primary': day.isOpen, 'text-hint': !day.isOpen}"></mat-icon>
                    <span class="text-sm text-secondary whitespace-nowrap">{{ day.isOpen ? 'Open' : 'Closed' }}</span>
                </button>
            </div>

            <!-- 3. Time Slots / 24H View -->
            <div class="w-full">
                <ng-container *ngIf="day.isOpen; else closedTemplate">

                    <!-- View if 24 Hours -->
                    <div *ngIf="isDay24Hours(day); else manualSlots" class="flex items-center h-[40px] px-1">
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
                            Open 24 Hours
                        </span>
                        <button mat-button color="primary" class="ml-4 text-xs" (click)="handleToggleOpen(dayIdx); handleToggleOpen(dayIdx)">
                            Reset to Hours
                        </button>
                    </div>

                    <!-- View if Manual Time Slots -->
                    <ng-template #manualSlots>
                        <div class="space-y-2">
                            <div *ngFor="let slot of day.timeSlots; let slotIdx = index"
                                 class="flex items-center space-x-1 sm:space-x-2 w-full">

                                <mat-form-field class="flex-1 min-w-[110px]" appearance="outline" subscriptSizing="dynamic">
                                    <mat-select [value]="slot.openTime"
                                                (valueChange)="handleTimeChange(day, slot, 'openTime', $event)">
                                        <mat-option *ngFor="let time of timeOptions" [value]="time">{{ time }}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <span class="text-secondary">-</span>

                                <mat-form-field class="flex-1 min-w-[110px]" appearance="outline" subscriptSizing="dynamic">
                                    <mat-select [value]="slot.closeTime"
                                                (valueChange)="handleTimeChange(day, slot, 'closeTime', $event)">
                                        <mat-option *ngFor="let time of timeOptions" [value]="time">{{ time }}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <button mat-icon-button color="warn" type="button"
                                        (click)="handleRemoveSlot(dayIdx, slotIdx)"
                                        matTooltip="Remove slot">
                                    <mat-icon svgIcon="heroicons_solid:x-circle" class="icon-size-5"></mat-icon>
                                </button>
                            </div>

                            <!-- Buttons: Add Slot & Set 24h -->
                            <div class="flex items-center space-x-2 pt-1">
                                <button *ngIf="day.timeSlots.length < 2"
                                        mat-stroked-button color="primary" type="button" class="small-btn"
                                        (click)="handleAddSlot(dayIdx)">
                                    <mat-icon svgIcon="heroicons_outline:plus-circle" class="icon-size-4 mr-1"></mat-icon>
                                    Add Slot
                                </button>

                                <button mat-stroked-button type="button" class="small-btn text-secondary"
                                        (click)="set24Hours(dayIdx)" matTooltip="Set to Open 24 Hours">
                                    24h
                                </button>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>

                <ng-template #closedTemplate>
                    <div class="text-xs text-hint italic pt-2.5 px-1">
                        Closed
                    </div>
                </ng-template>
            </div>

            <!-- 4. Row Actions (Copy) -->
            <div class="pt-1 flex justify-end">
                <button mat-icon-button [matMenuTriggerFor]="copyMenu"
                        matTooltip="Copy these hours..." aria-label="Copy hours options">
                    <mat-icon svgIcon="heroicons_outline:clipboard-document" class="text-secondary icon-size-5"></mat-icon>
                </button>
                <mat-menu #copyMenu="matMenu">
                    <button mat-menu-item (click)="copyHoursTo(day, 'all')">
                        <span>Copy to All Days</span>
                    </button>
                    <button mat-menu-item (click)="copyHoursTo(day, 'weekdays')">
                        <span>Copy to Weekdays (Mon-Fri)</span>
                    </button>
                    <button mat-menu-item (click)="copyHoursTo(day, 'weekends')">
                        <span>Copy to Weekends (Sat-Sun)</span>
                    </button>
                </mat-menu>
            </div>

        </div>
    </ng-container>
</div>

<!-- Optional Helper SCSS for smaller buttons -->
<style>
    .small-btn {
        line-height: 28px;
        height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }
</style>
